import Vue from 'vue'
import Router from 'vue-router'
import regist_QRcode from '@/components/regist_QRcode'
import index from '@/components/index'//首页
import login from '@/components/login'//登录
import warn_index from '@/components/warn_index'//预警面板
//系统设置
import buffer_manage from '@/components/set/buffer_manage'//日志缓存管理
import dict_info from '@/components/set/dict_info'//字典信息管理
import dict_type from '@/components/set/dict_type'//字典类型管理
import menu from '@/components/set/menu'//权限管理
import role from '@/components/set/role'//角色管理
//用户管理
import query from '@/components/user/query'//用户管理
import personal_data from '@/components/user/personal_data'//个人资料
import change_password from '@/components/user/change_password'//修改密码
//冷链事务
import back from '@/components/cold/back'//设备签回
import batch from '@/components/cold/batch'//批次管理
import manage from '@/components/cold/manage'//冷链管理
import batch_details from '@/components/cold/batch_details'//批次明细
import device_view from '@/components/cold/device_view'//设备总览
import truck_detail from '@/components/cold/truck_detail'//冷链车监控详情
import temp_detail from '@/components/cold/temp_detail'//温度记录仪详情
import cold_storage_detail from '@/components/cold/cold_storage_detail'//冷库监控详情
import alarm_manage from '@/components/cold/alarm_manage'//报警管理
import cold_storage_data from '@/components/cold/cold_storage_data'//冷库数据查询
import warehouse_manage from '@/components/cold/warehouse_manage'//库房管理
//订单管理
import stock_in from '@/components/order/stock_in'//入库单管理
import stock_out from '@/components/order/stock_out'//出库单管理
//基础档案
import device_list from '@/components/record/device_list'//设备管理
import client from '@/components/record/client'//客户档案
import product from '@/components/record/product'//产品档案
import storage from '@/components/record/storage'//仓库管理
import check_plan from '@/components/record/check_plan'//查看平面图
//库存管理
import business from '@/components/store/business'//库存事务
import store_query from '@/components/store/query'//库存查询
//工单管理
import work_my from '@/components/work_order/my'//我的工单
import manage_list from '@/components/work_order/manage_list'//工单管理列表
//定时任务
import log_warning from '@/components/timed_task/log_warning'//日志预警
import warn_list from '@/components/timed_task/warn_list'//预警列表
//自定义报表
import report_manage from '@/components/report/manage'//报表管理
import report_query from '@/components/report/query'//查询报表
//费用管理
import expense_message from '@/components/expense/message'//耗材费用基础信息
import indoor from '@/components/expense/indoor'//本地费用
import expense_manage from '@/components/expense/manage'//耗材费用管理
import province from '@/components/expense/province'//外地费用
//外链组件
import get_file from '@/components/get_file'

Vue.use(Router)


const originalReplace = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalReplace.call(this, location).catch(err => err);
};


export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      meta:{
        title:'登录-供应链协同管理平台'
      }
    },
    {
      path: '/regist_QRcode',
      name: 'regist_QRcode',
      component: regist_QRcode,
      meta:{
        title:'注册--SCCMS'
      }
    },
    {
      path: '/get_file',
      name: 'get_file',
      component: get_file,
      meta:{
        title:'库存信息'
      }
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta:{
        title:'供应链协同管理平台'
      },
      children:[
        {
          path: '/warn_index',
          name: 'warn_index',
          component: warn_index,
          meta:{
            title:'任务面板'
          }
        },
        //系统设置
        {
          path: '/set/buffer_manage',
          name: 'buffer_manage',
          component: buffer_manage,
          meta:{
            title:'缓存管理'
          }
        },
        {
          path: '/set/dict_info',
          name: 'dict_info',
          component: dict_info,
          meta:{
            title:'字典信息'
          }
        },
        {
          path: '/set/dict_type',
          name: 'dict_type',
          component: dict_type,
          meta:{
            title:'字典类型'
          }
        },
        {
          path: '/set/menu',
          name: 'menu',
          component: menu,
          meta:{
            title:'权限'
          }
        },
        {
          path: '/set/role',
          name: 'role',
          component: role,
          meta:{
            title:'角色'
          }
        },
        //用户管理
        {
          path: '/user/query',
          name: 'query',
          component: query,
          meta:{
            title:'查询用户'
          }
        },
        {
          path: '/user/personal_data',
          name: 'personal_data',
          component: personal_data,
          meta:{
            title:'个人资料'
          }
        },
        {
          path: '/user/change_password',
          name: 'change_password',
          component: change_password,
          meta:{
            title:'修改密码'
          }
        },
        //冷链事务
        {
          path: '/cold/back',
          name: 'back',
          component: back,
          meta:{
            title:'设备签回'
          }
        },
        {
          path: '/cold/batch',
          name: 'batch',
          component: batch,
          meta:{
            title:'批次管理'
          }
        },
        {
          path: '/cold/manage',
          name: 'manage',
          component: manage,
          meta:{
            title:'冷链管理'
          }
        },
        {
          path: '/cold/batch_details',
          name: 'batch_details',
          component: batch_details,
          meta:{
            title:'批次明细'
          }
        },
        {
          path: '/cold/device_view',
          name: 'device_view',
          component: device_view,
          meta:{
            title:'设备总览'
          }
        },
        {
          path: '/cold/truck_detail',
          name: 'truck_detail',
          component: truck_detail,
          meta:{
            title:'冷链车监控详情'
          }
        },
        {
          path: '/cold/temp_detail',
          name: 'temp_detail',
          component: temp_detail,
          meta:{
            title:'温度记录仪详情'
          }
        },
        {
          path: '/cold/cold_storage_detail',
          name: 'cold_storage_detail',
          component: cold_storage_detail,
          meta:{
            title:'冷库监控详情'
          }
        },
        {
          path: '/cold/alarm_manage',
          name: 'alarm_manage',
          component: alarm_manage,
          meta:{
            title:'报警管理'
          }
        },
        {
          path: '/cold/cold_storage_data',
          name: 'cold_storage_data',
          component: cold_storage_data,
          meta:{
            title:'冷库数据查询'
          }
        },
        {
          path: '/cold/warehouse_manage',
          name: 'warehouse_manage',
          component: warehouse_manage,
          meta:{
            title:'库房管理'
          }
        },
        //订单管理
        {
          path: '/order/stock_in',
          name: 'stock_in',
          component: stock_in,
          meta:{
            title:'入库单管理'
          }
        },
        {
          path: '/order/stock_out',
          name: 'stock_out',
          component: stock_out,
          meta:{
            title:'出库单管理'
          }
        },
        //基础档案
        {
          path: '/record/device_list',
          name: 'device_list',
          component: device_list,
          meta:{
            title:'设备管理'
          }
        },
        {
          path: '/record/client',
          name: 'client',
          component: client,
          meta:{
            title:'客户档案'
          }
        },
        {
          path: '/record/product',
          name: 'product',
          component: product,
          meta:{
            title:'产品档案'
          }
        },
        {
          path: '/record/storage',
          name: 'storage',
          component: storage,
          meta:{
            title:'仓库管理'
          }
        },
        {
          path: '/record/check_plan',
          name: 'check_plan',
          component: check_plan,
          meta:{
            title:'查看平面图'
          }
        },
        //库存管理
        {
          path: '/store/business',
          name: 'business',
          component: business,
          meta:{
            title:'库存事务'
          }
        },
        {
          path: '/store/query',
          name: 'store_query',
          component: store_query,
          meta:{
            title:'库存查询'
          }
        },
        //工单管理
        {
          path: '/work_order/my',
          name: 'work_my',
          component: work_my,
          meta:{
            title:'我的工单'
          }
        },
        {
          path: '/work_order/manage_list',
          name: 'manage_list',
          component: manage_list,
          meta:{
            title:'工单管理列表'
          }
        },
        //定时任务
        {
          path: '/timed_task/log_warning',
          name: 'log_warning',
          component: log_warning,
          meta:{
            title:'日志预警'
          }
        },
        {
          path: '/timed_task/warn_list',
          name: 'warn_list',
          component: warn_list,
          meta:{
            title:'预警列表'
          }
        },
        //自定义报表
        {
          path: '/report/manage',
          name: 'report_manage',
          component: report_manage,
          meta:{
            title:'报表管理'
          }
        },
        {
          path: '/report/query',
          name: 'report_query',
          component: report_query,
          meta:{
            title:'查询报表'
          }
        },
        //费用管理
        {
          path: '/expense/message',
          name: 'expense_message',
          component: expense_message,
          meta:{
            title:'耗材费用基础信息'
          }
        },
        {
          path: '/expense/indoor',
          name: 'indoor',
          component: indoor,
          meta:{
            title:'本地费用'
          }
        },
        {
          path: '/expense/manage',
          name: 'expense_manage',
          component: expense_manage,
          meta:{
            title:'耗材费用管理'
          }
        },
        {
          path: '/expense/province',
          name: 'province',
          component: province,
          meta:{
            title:'外地费用'
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{
        title:'登录-供应链协同管理平台'
      }
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js